import http from "@core/fetch";
import { components } from "@apiSchema";
import { useData } from "@hooks/useData";

type Response = components["schemas"]["LatestNewsAndPublicationsWrapper"];

async function getHomeReports(): Promise<Response> {
    const response = await http.get('get home reports and news');

    return response as Response;
}

export function useHomeReportsAndNews() {
    return useData({
        publications: [],
        news: [],
    }, getHomeReports);
}